<template>
  <div class="home" id="home">
    <home-carousel @buttonClick="carouselClick"></home-carousel>
    <home-image-dock/>
    <home-collections/>
    <home-projects-resume id="projects"/>
    <AppRSSFeedContainer/>
    <AppNewsletter/>
    <AppFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import HomeCarousel from '@/components/HomeCarousel'
import AppNewsletter from 'mschools-components/src/components/AppNewsletter'
import AppRSSFeedContainer from 'mschools-components/src/components/AppRSSFeedContainer'
import AppFooter from 'mschools-components/src/components/AppFooter'
import HomeProjectsResume from '@/components/HomeProjectsResume'
import HomeImageDock from '@/components/HomeImageDock'
import HomeCollections from '@/components/HomeCollections'
import Velocity from 'velocity-animate'

export default {
  name: 'home',
  components: {
    AppNewsletter,
    AppRSSFeedContainer,
    AppFooter,
    HomeCarousel,
    HomeImageDock,
    HomeProjectsResume,
    HomeCollections
  },
  created () {
    this.fetchCapsules().then(() => {})
  },
  mounted () {
  },
  destroyed () {
    // clearInterval(this.activeCapsuleInterval)
  },
  data () {
    return {
      activeIndex: 0,
      activeImage: '',
      enterActiveClass: 'animated faster fadeInUp',
      enterActiveClassMobile: 'animated faster slideInRight',
      leaveActiveClassMobile: 'animated faster slideOutLeft'
    }
  },
  computed: {
    ...mapGetters({ capsules: 'formattedCapsules', isLoggedIn: 'isLoggedIn' }),
    activeCapsule: function () {
      return this.capsules[this.activeIndex] || {}
    }
  },
  filters: {
    localPath: name => {
      return require(`@/assets/${name}@2x.png`)
    }
  },
  methods: {
    ...mapActions(['fetchCapsules', 'getCapsuleFiles']),
    enter: function (el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          /* { opacity: 1, height: '1.6em' } */ {},
          { complete: done }
        )
      }, delay)
    },
    carouselClick: function () {
      this.$scrollTo('#projects')
    }
  },
  watch: {
    activeIndex: function (newIndex, oldIndex) {
      this.enterActiveClassMobile =
        newIndex > oldIndex
          ? 'animated faster slideInRight'
          : 'animated faster slideInLeft'

      this.leaveActiveClassMobile =
        newIndex > oldIndex
          ? 'animated faster slideOutLeft'
          : 'animated faster slideOutRight'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/sass/msteam-style";
@import "~bulma/sass/utilities/initial-variables";
.image > img {
  position: absolute;
  left: 50%;
  top: 75%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.has-shadow {
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.page-indicator {
  height: 10px;
  width: 10px;
  margin: 5px;
  background-color: #f2f2f2;
  border-radius: 50%;
}
.active {
  //background-color: $link;
  transition: all 1s;
}
.capsule-icon {
  height: 74px;
  width: 74px;
  transform: translateY(4px);
  /*margin: auto;*/
}
.active-capsule-icon {
  // border: 2px solid $link;
  height: 86px;
  width: 86px;
  border-radius: 50%;
  transition: border 0.3s;
}

.floating-card {
  position: absolute;
  top: 25%;
  left: 40px;
  right: 150px;
  bottom: 0;
}
.nav-arrow {
  border: #fafafa 2px solid;
  border-radius: 50% !important;
  top: 50%;
}

.rounded {
  border-radius: 50%;
}
.capsule-box {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 40%;
  height: 90%;
  max-width: 430px;
  max-height: 420px;
  top: -5%;
  left: 5%;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.5);
  .content {
    flex: 1;
  }
}

.is-text-overflow {
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
}

.level-right .level-item {
  margin-right: 50px;
}
section:nth-child(2n-1) {
  .title {
    color: $squash;
  }
}
</style>
